export default function isContains(element, str) {
  return element.classList.contains(str);
}